import { RootState, StoreConstants } from '@/types';
import { NavigationState } from '@/types/store/navigation';
import { GetterTree } from 'vuex';

export const getters: GetterTree<NavigationState, RootState> = {
  [StoreConstants.Navigation.Getters.DocumentViewBackRoute](state): string | null {
    return state.documentViewBackRoute;
  },
  [StoreConstants.Navigation.Getters.DocumentViewBackRouteLabel](state): string | null {
    return state.documentViewBackRouteLabel;
  },
  [StoreConstants.Navigation.Getters.DocumentViewBackRouteParams](state): Record<string, any> | null {
    return state.documentViewBackRouteParams;
  }
};
